export const WinAmountViewGrid = {
	size: 100,
	gap: 0,
	name: 'WinAmountViewGrid',
	padding: {
		left: 5,
		// right: 5,
		portrate: {
			left: 3,
			right: 3
		},
		landscape: {
			left: 5
			// right: 5,
		}
	},
	main: [
		{
			name: 'empty',
			size: 3
		},
		{
			name: 'statusbar1',
			size: 97,
			type: 'PortrateGridController',
			config: {
				name: 'statusbar2',
				size: 100,
				gap: 0,
				align: 'left',
				main: [
					{
						name: 'empty',
						size: 85
					},
					{
						name: 'statusbar3',
						type: 'LandscapeGridController',
						size: 6,
						config: {
							size: 100,
							gap: 0,
							name: 'statusbar4',
							main: [
								{
									name: 'empty',
									size: 30
								},
								{
									name: 'empty',
									size: 35
								},
								{
									name: 'WinAmount',
									size: 30,
									align: 'right_center',
									height: 40,
									bounds: {
										width: 70,
										height: 20
									}
								}
							]
						}
					}
				]
			}
		}
	],
	landscape: [
		{
			name: 'empty',
			size: 3
		},
		{
			name: 'statusbar1',
			size: 97,
			type: 'PortrateGridController',
			config: {
				name: 'statusbar2',
				size: 100,
				gap: 0,
				align: 'left',
				main: [
					{
						name: 'empty',
						size: 94
					},
					{
						name: 'statusbar3',
						type: 'LandscapeGridController',
						size: 6,
						config: {
							size: 100,
							gap: 0,
							name: 'statusbar4',
							main: [
								{
									name: 'empty',
									size: 30
								},
								{
									name: 'empty',
									size: 35
								},
								{
									name: 'WinAmount',
									size: 30,
									align: 'right_center',
									height: 40,
									bounds: {
										width: 50,
										height: 20
									}
								}
							]
						}
					}
				]
			}
		}
	],
	portrate: [
		{
			name: 'empty',
			size: 94
		},
		{
			name: 'statusbar100',
			type: 'LandscapeGridController',
			size: 6,
			config: {
				size: 90,
				gap: 0,
				maxWidth: 'reel',
				name: 'statusbar60',
				main: [
					{
						name: 'empty',
						size: 30,
						align: 'left_center'
					},
					{
						name: 'empty',
						size: 30,
						align: 'center'
					},

					{
						name: 'WinAmount',
						size: 30,
						align: 'right_center',
						bounds: {
							width: 12,
							height: 60
						}
					}
				]
			}
		}
	]
};
